let scrollPosition = 0;
const scrollStep = 300;
const prevButton = document.querySelector(".swiper-button-prev");

function scrollProducts(direction) {
  const scroller = document.querySelector(".scroller");
  if (direction === "prev") {
    scrollPosition -= scrollStep;
  } else if (direction === "next") {
    scrollPosition += scrollStep;
  }

  scrollPosition = Math.min(
    Math.max(scrollPosition, 0),
    scroller.scrollWidth - scroller.clientWidth
  );

  scroller.scrollTo({
    top: 0,
    left: scrollPosition,
    behavior: "smooth",
  });

  updateButtonState(scroller.scrollLeft);
}

function updateButtonState(scrollLeft) {
  if (scrollLeft <= 0) {
    prevButton.style.opacity = "0.5";
    prevButton.style.cursor = "not-allowed";
  } else {
    prevButton.style.opacity = "1";
    prevButton.style.cursor = "pointer";
  }
}

updateButtonState(0);

document.querySelector(".scroller").addEventListener("scroll", function () {
  updateButtonState(this.scrollLeft);
});
